<ds-listable-object-component-loader [object]="object"
                                     [viewMode]="viewModes.ListElement"
                                     [index]="index"
                                     [linkType]="linkType"
                                     [listID]="listID"></ds-listable-object-component-loader>
<ds-item-admin-search-result-actions-element [item]="dso" [small]="false"></ds-item-admin-search-result-actions-element>
